import { ActionTypes } from "../actions"

const translations = (state = {}, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_TRANSLATIONS:
      return action.response
    default:
      return state
  }
}

export default translations

export const getTranslationTexts = (state: any) => state

export const getTranslationTextsByScope = (state: any, scope: string) =>
  state[scope] || {}

export const getTranslationTextsByScopes = (state: any, scopes: string[]) =>
  scopes.reduce((accumulator, scope) => {
    return { ...accumulator, ...state[scope] }
  }, {})
